import styled from '@emotion/styled'
import { useFormContext, Controller } from 'react-hook-form'
import { Input } from 'antd'

import { VendorProfileFormType } from '../type'

import SectionWrapper from './SectionWrapper'
import InputField from './InputField'
import ErrorMessage from './ErrorMessage'

const BusinessInfoForm = () => {
	const {
		control,
		formState: { errors },
	} = useFormContext<VendorProfileFormType>()

	return (
		<SectionWrapper title="사업자 정보">
			<Section>
				<InputField label="사업자 등록번호">
					<Controller
						control={control}
						name="businessRegistrationNumber"
						render={({ field }) => {
							return <Input {...field} disabled />
						}}
					/>
				</InputField>
				<InputField label="통신판매업 신고번호">
					<Controller
						control={control}
						name="salesReportNumber"
						render={({ field }) => {
							return <Input {...field} disabled />
						}}
					/>
				</InputField>
				<InputField label="업체(법인)명">
					<Controller
						control={control}
						name="companyName"
						render={({ field }) => {
							return (
								<Input
									{...field}
									status={errors.companyName && 'error'}
									placeholder="업체(법인)명을 입력해주세요."
								/>
							)
						}}
					/>
					<ErrorMessage errorMessage={errors.companyName?.message} />
				</InputField>
				<InputField label="대표자 명">
					<Controller
						control={control}
						name="ceoName"
						render={({ field }) => {
							return (
								<Input
									{...field}
									status={errors.ceoName && 'error'}
									placeholder="대표자 명을 입력해주세요."
								/>
							)
						}}
					/>
					<ErrorMessage errorMessage={errors.ceoName?.message} />
				</InputField>
				<InputField label="사업장 소재지">
					<Controller
						control={control}
						name="address"
						render={({ field }) => {
							return (
								<Input
									{...field}
									status={errors.address && 'error'}
									placeholder="사업장 소재지를 입력해주세요."
								/>
							)
						}}
					/>
					<ErrorMessage errorMessage={errors.address?.message} />
				</InputField>
				<InputField label="대표자 이메일">
					<Controller
						control={control}
						name="email"
						render={({ field }) => {
							return (
								<Input
									{...field}
									status={errors.email && 'error'}
									placeholder="대표자 이메일을 입력해주세요."
								/>
							)
						}}
					/>
					<ErrorMessage errorMessage={errors.email?.message} />
				</InputField>
				<InputField label="대표 연락처">
					<Controller
						control={control}
						name="phone"
						render={({ field }) => {
							return (
								<Input
									{...field}
									status={errors.phone && 'error'}
									placeholder="대표 연락처을 입력해주세요."
								/>
							)
						}}
					/>
					<ErrorMessage errorMessage={errors.phone?.message} />
				</InputField>
			</Section>
		</SectionWrapper>
	)
}

const Section = styled.div`
	display: flex;
	flex-direction: column;
`

export default BusinessInfoForm
